/**
 * WARNING: This file is being updated shortly to use our new batch tracking system.
 * Please do not make significant changes until the migration is complete.
 */

export const batches = [
    {
        id: 'ARB4',
        name: 'Single Blend Aged Yumi Rum – 2 Years Old',
        subtitle: 'This is our second 2 years old blend and the first aged pure cane rum we released. These barrels were emptied and the bottles filled in November, 2023.',
        blend: {
            title: 'Single Blend',
            description: 'We shortlisted a dozen barrels of at least two years old. These were carefully profiled and blended in various combinations to find the ideal mix for this second age-statement release. After much experimentation, the result was a blend that stood out as the best and most harmonious. This selection ultimately became our first aged pure cane rum, crafted from our current stock of two-year-old barrels.',
        },
        barrels: {
            title: 'Barrels',
            description: 'We combined barrels #PBK182, #HHBK105, #BFJDK197 and #JBK203. These barrels were all aged in the "cave" of the distillery and enjoyed one of the most stable environment we have to offer our barrels. They are all used bourbon barrels respectively from, Peerless Distilling, Heaven Hill Distillery, Brown Forman Group and Jim Beam Distillery.',
            stats: 'These barrels lost on average 11.2% of their weight over the course of ageing and because of the high humidity environment of our production floor (78.8% Average - Max 89.7% - Min 59.8%) they have lost 16.68% of their alcohol content.',
            table: [
                { batch: 'PBK182', age: '2.28', fillingDate: '1 September 2021', blendPercentage: '24.51%' },
                { batch: 'HHBK105', age: '2.2', fillingDate: '1 October 2021', blendPercentage: '26.33%' },
                { batch: 'BFJDK197', age: '2.2', fillingDate: '1 October 2021', blendPercentage: '23.87%' },
                { batch: 'JBK203', age: '2.28', fillingDate: '31 August 2021', blendPercentage: '25.30%' },
            ],
        },
        volume: {
            title: 'Production Volume',
            description: 'The volume of this batch is 663.4 litres.',
            bottles: [
                '540 Bottles of 200ml',
                '846 Bottles of 750ml',
            ]
        }
    },
    {
        id: 'ARB2',
        name: 'Select Barrels - Single Blend Ex-Brandy – 3 Years Old',
        subtitle: 'This is our first 3 years old release and our first blend of ex-brandy barrels. It is a selection of three of our best barrels and we exclusively selected Ex-Brandy barrels in order to be able to compare the ageing of this very specific type of barrel. The barrels were emptied on August 28, 2023.',
        blend: {
            title: 'Single Blend',
            description: 'The barrel selection process involved sampling and tasting of over 30 barrels. From that we shortlisted a dozen barrels of at least 3 years old. We profiled them and did various blending to find a mix that would be suitable for this second age statement release. These three barrels create a nice harmonious long-lasting flavour.',
        },
        barrels: {
            title: 'Barrels',
            description: 'We combined barrels #NABRMB43, #NABRMB49 and #NABRMB24. These barrels were aged on the production floor of the distillery and our barn. They were partly exposed to the sun during the later part of the day and got exposed to higher temperature in the barn.',
            stats: 'These barrels lost on average 15.46% of their weight over the course of ageing and because of the high humidity environment of the distillery they have lost 28.79% of their alcohol content.',
            table: [
                { batch: 'NABRMB43', age: '3.3', fillingDate: '24 May 2020', blendPercentage: '33.66%' },
                { batch: 'NABRMB49', age: '3.3', fillingDate: '24 May 2020', blendPercentage: '33.31%' },
                { batch: 'NABRMB24', age: '3.85', fillingDate: '21 October 2019', blendPercentage: '33.03%' },
            ],
        },
        volume: {
            title: 'Production Volume',
            description: 'The volume of this batch is 436.2 litres. This batch was release in three different format and two different strengths at 42% and cask strength at 57.3%',
            bottles: [
                'Cask Strength 57.3%',
                '198 Bottles of 750ml',
                'Regular Strength 42%',
                '120 Bottles of 50ml',
                '500 Bottles of 200ml',
                '396 Bottles of 750ml',
            ]
        }
    },
    {
        id: 'ARB3',
        name: 'Select Barrels - Single Blend Ex-Rye – 3 Years Old',
        subtitle: 'This is our first 3 years old release and our first blend of Ex-Rye barrels. It is a selection of three of our best barrels and we exclusively selected Ex-Rye barrels in order to be able to compare the ageing of this very specific type of barrel. The barrels were emptied on August 28, 2023',
        blend: {
            title: 'Single Blend',
            description: 'The barrel selection process involved sampling and tasting of over 30 barrels. From that we shortlisted a dozen barrels of at least 3 years old. We profiled them and did various blending to find a mix that would be suitable for this second age statement release. These three barrels create a nice harmonious long-lasting flavour.',
        },
        barrels: {
            title: 'Barrels',
            description: 'We combined barrels #SCRRMB7, #SCRRMB6 and #SCRRMB10. These barrels were all aged on the production floor of the distillery and exposed to the sun during the later part of the day. They are respectively, a used bourbon barrel that comes from Woodford Reserve Distillery, a Second-fill American Brandy Barrel (first-fill Bourbon) and a used Chardonnay French barrique.',
            stats: 'These barrels lost on average 16.57% of their weight over the course of ageing and because of the high humidity environment of our production floor they have lost 27.56% of their alcohol content.',
            table: [
                { batch: 'SCRRMB7', age: '3.25', fillingDate: '27 May 2020', blendPercentage: '30.75%' },
                { batch: 'SCRRMB6', age: '3.35', fillingDate: '21 April 2020', blendPercentage: '37.44%' },
                { batch: 'SCRRMB10', age: '3.85', fillingDate: '21 October 2019', blendPercentage: '31.81%' },
            ],
        },
        volume: {
            title: 'Production Volume',
            description: 'The volume of this batch is 436.2 litres. This batch was release in three different format and two different strengths at 45% and cask strength at 58%',
            bottles: [
                'Cask Strength 58%',
                '198 Bottles of 750ml',
                'Regular Strength 45%',
                '120 Bottles of 50ml',
                '504 Bottles of 200ml',
                '327 Bottles of 750ml',
            ]
        }
    },
    {
        id: 'ARB1',
        name: 'Single Blend Aged Rum – 2 Years Old',
        subtitle: 'This release is the first time we ever released a rum with an age statement that is not a single cask. At the time of bottle filling, it is our oldest rum we ever released. The barrels were emptied and the bottles filled on November 4, 2022.',
        blend: {
            title: 'Single Blend',
            description: 'The barrel selection process involved sampling and tasting of over 100 barrels. From that we shortlisted a dozen barrels of at least 2 years old. We profiled them and did various blending to find a mix that would be suitable for this first age statement release. These three barrels create a nice harmonious long-lasting flavour.',
        },
        barrels: {
            title: 'Barrels',
            description: 'We combined barrels #WRBRMB53, #NABRMB42 and #CF71. These barrels were all aged on the production floor of the distillery and exposed to the sun during the later part of the day. They are respectively, a used bourbon barrel that comes from Woodford Reserve Distillery, a Second-fill American Brandy Barrel (first-fill Bourbon) and a used Chardonnay French barrique.',
            stats: 'These barrels lost on average 9.31% of their weight over the course of ageing and because of the high humidity environment of our production floor (78.8% Average - Max 89.7% - Min 59.8%) they have lost 15.65% of their alcohol content.',
            table: [
                { batch: 'WRBRMB53', age: '2.39', fillingDate: '19 June 2020', blendPercentage: '33.20%' },
                { batch: 'NABRMB42', age: '2.5', fillingDate: '15 May 2020', blendPercentage: '31.74%' },
                { batch: 'CF71', age: '2.75', fillingDate: '7 February 2020', blendPercentage: '35.06%' },
            ],
        },
        volume: {
            title: 'Production Volume',
            description: 'The volume of this batch is 825 litres. This batch was release in three different format.',
            bottles: [
                '480 Bottles of 45ml',
                '420 Bottles of 200ml',
                '700 Bottles of 750ml',
            ]
        }
    },
    {
        id: 'YRB1',
        name: 'Single Farm Origin Pure Cane Rum - Yumi Rum - 2022',
        subtitle: "Presenting the first batch of Yumi Rum bottled in 2022, made from the finest locally-grown sugarcane from Job Charley's Field in Greenhill, Efate. This batch is only 12 km away from the 83 Islands Distillery, nestled deep in the lush bush.",
        resting: {
            title: 'Resting',
            description: 'This batch underwent minimal resting of just 2 weeks in stainless steel tanks. Our heart for this cut averages around 90% ABV. The high purity of the rum means that it does not require any additional evaporation of its components that is normally required for Agricole Rum. It is a truly fine rum.',
        },
        volume: {
            title: 'Production Volume',
            description: 'This batch of Yumi Rum, produced in 2022, has a fermentation of 7.7% ABV and yields a total of 96.75 litres of pure alcohol. Limited in quantity, this release is a unique opportunity to experience the quality and flavor of Yumi Rum.',
            bottles: []
        }
    },
    {
        id: 'YRB2',
        name: 'Single Farm Origin Pure Cane Rum - Yumi Rum - 2023',
        subtitle: "Presenting the first batch of Yumi Rum bottled in 2023, made from the finest locally-grown sugarcane from Touaraken Farm on Efate. This batch is only 12 km away from the 83 Islands Distillery, nestled deep in the lush bush.",
        resting: {
            title: 'Resting',
            description: 'This batch underwent minimal resting of just 2 weeks in stainless steel tanks. Our heart for this cut averages around 90% ABV. The high purity of the rum means that it does not require any additional evaporation of its components that is normally required for Agricole Rum. It is a truly fine rum.',
        },
        volume: {
            title: 'Production Volume',
            description: 'This batch of Yumi Rum, produced in 2022, has a fermentation of 7.7% ABV and yields a total of 96.75 litres of pure alcohol. Limited in quantity, this release is a unique opportunity to experience the quality and flavor of Yumi Rum.',
            bottles: []
        }
    },
    {
        id: 'YRB3',
        name: 'Single Farm Origin Pure Cane Rum - Yumi Rum - 2023',
        subtitle: "Presenting the first batch of Yumi Rum bottled in 2023, made from the finest locally-grown sugarcane from Touaraken Farm on Efate. This batch is only 12 km away from the 83 Islands Distillery, nestled deep in the lush bush.",
        resting: {
            title: 'Resting',
            description: 'This batch underwent minimal resting of just 2 weeks in stainless steel tanks. Our heart for this cut averages around 90% ABV. The high purity of the rum means that it does not require any additional evaporation of its components that is normally required for Agricole Rum. It is a truly fine rum.',
        },
        volume: {
            title: 'Production Volume',
            description: 'This batch of Yumi Rum, produced in 2022, has a fermentation of 7.7% ABV and yields a total of 96.75 litres of pure alcohol. Limited in quantity, this release is a unique opportunity to experience the quality and flavor of Yumi Rum.',
            bottles: []
        }
    }
]; 